import React from "react"
import { Grid } from "@mui/material"
import { DrawerSeeker } from "@ui-seeker/core"

import { isEditUserSettingsProvidersDrawer, isOpenUserSettingsProvidersDrawer, userSettingProvidersFormData } from "../../../@signals"
import UserSettingProviderDrawerColor from "./Color"
import UserSettingProviderDrawerProviders from "./Providers"
import UserSettingProviderDrawerSubmit from "./Submit"


export default function UserSettingProviderDrawer() {

	return <DrawerSeeker
		hideActions
		title={isEditUserSettingsProvidersDrawer.value ? 'Edit provider' : 'New provider'}
		isOpen={isOpenUserSettingsProvidersDrawer.value}
		controller={() => userSettingProvidersFormData.value = { }}
		successText="save"
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<UserSettingProviderDrawerProviders />
			</Grid>

			<Grid item xs={12}>
				<UserSettingProviderDrawerColor />
			</Grid>

			<Grid item xs={12} sx={{  display: 'flex', justifyContent: 'flex-end'  }}>
				<UserSettingProviderDrawerSubmit />
			</Grid>
		</Grid>
	</DrawerSeeker>
}